import React from 'react'
import CountUp from 'react-countup';
import {Container, CardDeck, Card, Row, Col} from 'react-bootstrap';
import {useInView} from 'react-intersection-observer';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faArrowRight} from '@fortawesome/free-solid-svg-icons'
import '../styles/components/kpi.css';

const endpoint = "https://files-website-fablab.s3.amazonaws.com/kpi/"

const kpi_json = [
  [    
    { name: "Usuarios activos",  from: 175 , to: 0, img: "member-white.png"},
    { name: "Usuarios capacitados", from: 167 , to: 0, img: "engineering-white.png"},
    { name: "Proyectos", from: 66 , to: 0, img: "project-management-white.png"},
  ],
  [
    { name: "Campus/Sedes impactadas", from: 3 , to: 0, img: "school-white.png"},
    { name: "Carreras impactadas", from: 14 , to: 0, img: "graduation-hat-white.png"},
    { name: "Eventos masivos de vinculación", from: 6 , to: 0, img: "calendar-white.png"}, 
  ]
]
export const Kpi = () => {

  const { ref, inView } = useInView({
      threshold: 0,
      triggerOnce: true,
  })

  return (<>
    
    <Container className="backgroundVideo d-none d-md-block">
      <video rel="preload" autoPlay="autoplay" loop="loop" muted playsInline>
        <source rel="preload" src="/assets/videos/Display.mp4" type="video/mp4"/>
      </video>
    </Container>
 

    <Container fluid style={{backgroundColor:"var(--gray)", background:'linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7))', backgroundSize: 'cover'}}>
      <Container ref = {ref} className="fablab-container" id="indicadores">
        <Row>
          <Col>
            <h1 className="fablab-title white">Indicadores</h1>
          </Col>
          {/* <Col className="mt-3 mb-3 text-right d-none d-md-block">
            <a className="fablab-link moving white" target="_blank" rel="noreferrer" href="/indicadores">Más información <FontAwesomeIcon className="fablab-button-circle white" icon={faArrowRight}/></a>
          </Col> */}
        </Row>
        
        <Row>
          <Col>
            {
              kpi_json.map((kpi, index) => 
                <CardDeck key={index} ref = {ref} >
                  {
                    kpi.map(({name, from, to, img}) =>
                      <Card key={name} className="indicadoresCard text-center">
                        <Card.Body>
                          <img alt="" src={endpoint+img} className="indicadoresImage"></img>
                          <Card.Text>
                            <CountUp
                              start = {0} 
                              end={inView ? from: to}
                              duration = {9}
                              className = "indicadoresNumber white"
                            />
                          </Card.Text>
                          <p className="indicadoresName white">{name}</p>
                        </Card.Body>
                      </Card>
                    )
                  }
                </CardDeck>  
              )
            }
          </Col>
          
        </Row>
        <Row>
          <Col className="text-center d-block d-md-none">
            <a className="fablab-link moving white" target="_blank" rel="noreferrer" href="/indicadores">Más información <FontAwesomeIcon className="fablab-button-circle white" icon={faArrowRight}/></a>
          </Col>
        </Row>
      </Container>
    </Container></>
  )   
}
